import { AllVideosComponent } from './components/all-videos/all-videos.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { MaterialModule } from './modules/material.module';
import { CdkTableModule } from '@angular/cdk/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './_guards/auth.guard';
import { AdminGuard } from './_guards/admin.guard';
import { HeaderComponent } from './layouts/header/header.component';
import { SignupComponent } from './components/signup/signup.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { routing } from './app.routing';
import { SecureComponent } from './layouts/secure/secure.component';
import { AdminComponent } from './layouts/admin/admin.component';
import { PublicComponent } from './layouts/public/public.component';
import { UtilsService } from './services/utils.service';
import { LegalInfoService } from './services/legal-info.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MarkdownToHtmlModule } from 'ng2-markdown-to-html';
import { ErrorInfoService } from './services/error-info.service';
import { FaqService } from './services/faq.service';
import { AttractionsService } from './services/attractions.service';
import { LocationsService } from './services/locations.service';
import { DistrictsService } from './services/districts.service';
import { YourTripComponent } from './components/your-trip/your-trip.component';
import { ExploreService } from './services/explore.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchService } from './services/search.service';
import { NgxImageGalleryModule } from 'ngx-image-gallery';
import { ShareModule } from '@ngx-share/core';
import { WishListService } from './services/wish-list.service';
import { TripService } from './services/trip.service';
import { GuidesService } from './services/guides.service';
import { LanguageService } from './services/language.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UsersComponent } from './components/users/users.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { TagsComponent } from './components/tags/tags.component';
import { LocationsComponent } from './components/locations/locations.component';
import { AttractionsComponent } from './components/attractions/attractions.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { GuidesComponent } from './components/guides/guides.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { DocsComponent } from './components/docs/docs.component';
import { UserViewComponent } from './components/users/user-view/user-view.component';
import { NewFaqComponent } from './components/faqs/new-faq/new-faq.component';
import { FaqViewComponent } from './components/faqs/faq-view/faq-view.component';
import { TagViewComponent } from './components/tags/tag-view/tag-view.component';
import { NewTagComponent } from './components/tags/new-tag/new-tag.component';
import { NewLocationComponent } from './components/locations/new-location/new-location.component';
import { LocationViewComponent } from './components/locations/location-view/location-view.component';
import { NewAttractionComponent } from './components/attractions/new-attraction/new-attraction.component';
import { AttractionViewComponent } from './components/attractions/attraction-view/attraction-view.component';
import { OrganizationViewComponent } from './components/organizations/organization-view/organization-view.component';
import { NewOrganizationComponent } from './components/organizations/new-organization/new-organization.component';
import { NewGuideComponent } from './components/guides/new-guide/new-guide.component';
import { GuideViewComponent } from './components/guides/guide-view/guide-view.component';
import { LanguageViewComponent } from './components/languages/language-view/language-view.component';
import { NewLanguageComponent } from './components/languages/new-language/new-language.component';
import { NewDocComponent } from './components/docs/new-doc/new-doc.component';
import { DocViewComponent } from './components/docs/doc-view/doc-view.component';
import { ApiService } from './services/api.service';
import { TagInputModule } from 'ngx-chips';
import { UploadService } from './services/upload.service';
import { TrumbowygNgxModule } from 'trumbowyg-ngx';
import { AuthService } from './services/auth.service';
import { HighlightModule } from 'ngx-highlightjs';
import { DataComponent } from './components/data/data.component';
import { ServicesComponent } from './components/services/services.component';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ServiceViewComponent } from './components/services/services-view/service-view.component';
import { ServicesService } from './services/services.service';
import { NewServiceComponent } from './components/services/new-services/new-service.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { ReviewsService } from './services/reviews.service';
import { OrganizationsService } from './services/organizations.service';
import { ReviewViewComponent } from './components/reviews/review-view/review-view.component';
import { NewReviewComponent } from './components/reviews/new-review/new-review.component';
import { environment } from '../environments/environment';
import { ErrorPolicy, FetchPolicy } from 'apollo-client';
import { TagService } from './services/tag.service';
import { FileService } from './services/file.service';
import { FileComponent } from './components/file/file.component';
import { AppInterceptor } from './app.interceptor';
import { ProgressSpinnerComponent } from './shared/progress-spinner/progress-spinner.component';
import { LoaderService } from './services/loader.service';
import { UsersService } from './services/users.service';
import { SearchInputComponent } from './shared/search-input/search-input.component';
import { DragulaModule } from 'ng2-dragula';
import { DzongkhaComponent } from './components/dzongkha/dzongkha.component';
import { NewDzongkhaComponent } from './components/dzongkha/new-dzongkha/new-dzongkha.component';
import { DzongkhaViewComponent } from './components/dzongkha/dzongkha-view/dzongkha-view.component';
import { DzongkhaService } from './services/dzongkha.service';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportsService } from './services/reports.service';
import { AllPhotosComponent } from './components/all-photos/all-photos.component';
import { LightBoxComponent } from './shared/light-box/light-box.component';
import { NewUserComponent } from './components/users/new-user/new-user.component';

import { ClipboardModule } from 'ngx-clipboard';
import { DocsService } from './services/docs.service';
import { ContactInquiryService } from './services/contact-inquiry.service';
import { ContactInquiriesComponent } from './components/contact-inquiries/contact-inquiries.component';
import { ContactInquiryViewComponent } from './components/contact-inquiries/contact-inquiry-view/contact-inquiry-view.component';
import { TeamsComponent } from './components/teams/teams.component';
import { NewTeamComponent } from './components/teams/new-team/new-team.component';
import { TeamViewComponent } from './components/teams/team-view/team-view.component';
import { TeamService } from './services/team.service';
import { ProsemirrorEditorComponent } from './shared/prosemirror-editor/prosemirror-editor.component';

@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    SecureComponent,
    AdminComponent,
    HeaderComponent,
    SignupComponent,
    LoginComponent,
    ResetPasswordComponent,
    YourTripComponent,
    DashboardComponent,
    UsersComponent,
    FaqsComponent,
    TagsComponent,
    LocationsComponent,
    AttractionsComponent,
    OrganizationsComponent,
    GuidesComponent,
    LanguagesComponent,
    DocsComponent,
    UserViewComponent,
    NewFaqComponent,
    FaqViewComponent,
    TagViewComponent,
    NewTagComponent,
    NewLocationComponent,
    LocationViewComponent,
    NewAttractionComponent,
    AttractionViewComponent,
    OrganizationViewComponent,
    NewOrganizationComponent,
    NewGuideComponent,
    GuideViewComponent,
    LanguageViewComponent,
    NewLanguageComponent,
    NewDocComponent,
    DocViewComponent,
    DataComponent,
    ServicesComponent,
    ServiceViewComponent,
    NewServiceComponent,
    ReviewsComponent,
    ReviewViewComponent,
    NewReviewComponent,
    FileComponent,
    ProgressSpinnerComponent,
    SearchInputComponent,
    DzongkhaComponent,
    NewDzongkhaComponent,
    DzongkhaViewComponent,
    ReportsComponent,
    AllPhotosComponent,
    LightBoxComponent,
    NewUserComponent,
    AllVideosComponent,
    ContactInquiriesComponent,
    ContactInquiryViewComponent,
    TeamsComponent,
    NewTeamComponent,
    TeamViewComponent,
    ProsemirrorEditorComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CdkTableModule,
    MaterialModule,
    routing,
    HttpClientModule,
    ApolloModule,
    HttpLinkModule,
    MarkdownToHtmlModule.forRoot(),
    FormsModule,
    NgxImageGalleryModule,
    ShareModule.forRoot(),
    TagInputModule,
    ReactiveFormsModule,
    DragulaModule.forRoot(),
    TrumbowygNgxModule.withConfig({
      svgPath: (document.location.hostname === 'localhost') && '../../admin/assets/trumbowyg-icons.svg' || 'assets/trumbowyg-icons.svg',
      removeformatPasted: true,
      autogrow: true,
      btns: [
        ['formatting'],
        ['unorderedList', 'orderedList'],
        ['strong', 'em', 'underline', 'del', 'removeformat'],
        ['link'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['fullscreen', 'viewHTML'],

      ]
    }),
    HighlightModule.forRoot(),
    ClipboardModule
  ],
  providers: [
    ApiService,
    AuthGuard,
    AdminGuard,
    OrganizationsService,
    AttractionsService,
    AuthService,
    DistrictsService,
    ErrorInfoService,
    ExploreService,
    GuidesService,
    FaqService,
    LanguageService,
    LegalInfoService,
    LocationsService,
    ReviewsService,
    ServicesService,
    SearchService,
    TripService,
    TagService,
    UploadService,
    UtilsService,
    WishListService,
    FileService,
    LoaderService,
    UsersService,
    DzongkhaService,
    ReportsService,
    DocsService,
    ContactInquiryService,
    TeamService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(apollo: Apollo, httpLink: HttpLink) {
    const fetchPolicy1: FetchPolicy = 'cache-and-network';
    const fetchPolicy2: FetchPolicy = 'network-only';
    const errorPolicy1: ErrorPolicy = 'ignore';
    const errorPolicy2: ErrorPolicy = 'all';
    const defaultOptions = {
      watchQuery: {
        fetchPolicy: fetchPolicy1,
        errorPolicy: errorPolicy1,
      },
      query: {
        fetchPolicy: fetchPolicy2,
        errorPolicy: errorPolicy2,
      },
      mutate: {
        errorPolicy: errorPolicy2
      }
    };
    apollo.create({
      link: httpLink.create({uri: environment.graphQLEndpoint}),
      cache: new InMemoryCache({addTypename: false}),
      defaultOptions: defaultOptions
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/app.module.ts